import { MESH_FIT_CONTROL_LABEL } from '../../lib/definitions/map';

interface MapCanvasControlsProps {
  fitToMesh: () => void;
  replay: { active: boolean; atMs: number | null };
  exitReplay: () => void;
  hover: { x: number; y: number; label: string } | null;
}

export function MapCanvasControls({ fitToMesh, replay, exitReplay, hover }: MapCanvasControlsProps) {
  return (<><button type="button" className="map-fit-btn" onClick={fitToMesh} title={MESH_FIT_CONTROL_LABEL}>
          {MESH_FIT_CONTROL_LABEL}
        </button>
{replay.active && (
          <div className="map-replay-banner">
            <span className="replay-badge">REPLAY</span>
            <span>{replay.atMs != null ? new Date(replay.atMs).toLocaleString() : ""}</span>
            <span className="map-replay-note">Map still shows current node positions — position history isn't available yet.</span>
            <button className="live-btn" onClick={exitReplay}>
              LIVE
            </button>
          </div>
        )}
{hover && (
          <div className="node-tooltip" style={{ left: hover.x, top: hover.y }}>
            {hover.label}
          </div>
        )}</>);
}
